$(document).ready(function() {
    $('footer#footer').before($('footer#footer .heurekaRating'))
    var storedData = sessionStorage.getItem('ratingData');
    if (storedData) {
        $('.heurekaTopLogo').after(storedData);
    } else {
        $.ajax({
            url: '/hodnoceni-obchodu/',
            type: 'GET',
            success: function(response) {
                var content = $(response);
                var rateAverageInner = parseFloat(content.find('.rate-average-inner .rate-average').html().trim().replace(',', '.'));
                var rateStarWrapStar = content.find('.rate-star-wrap .stars').html();
                var rateStarWrapStarsLabel = content.find('.rate-star-wrap .stars-label').html();
                var percentilRating = Math.floor(100*parseFloat(rateAverageInner)/5)
                var ratingsFinal = content.find('.votes-wrap').html();

                var finalHtml = '<div class="bottom">'
                finalHtml += '<div class="ratingStars"><span class="stars">'+rateStarWrapStar+'</span></div>'
                finalHtml += '<span class="ratingText"><span class="number">'+percentilRating+'</span>% zákazníků by doporučilo Ventila svým známým</span>'
                finalHtml += '<div class="text-center"><a href="/hodnoceni-obchodu/">'+rateStarWrapStarsLabel.split('(')[0].trim()+'</a></div>'
                finlRatings = '<div class="votes-wrap">'+ratingsFinal+'</div>'
                $('.heurekaTopLogo').after(finalHtml+finlRatings)

                sessionStorage.setItem('ratingData', finalHtml+finlRatings);
            },
            error: function(xhr, status, error) {
                console.error("Error fetching rating data:", status, error);
            }
        });
    }
});